(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rs-lot-table"] && !Shopify.designMode) return;
  try {
    (() => {
  const sync = () => {
    const id = new URLSearchParams(location.search).get('variant');
    if (!id) return;
    document.querySelectorAll('[data-rs-lot-table] tr[data-variant-id]').forEach((row) => {
      const on = row.dataset.variantId === id;
      row.classList.toggle('is-current', on);
      if (on) row.setAttribute('aria-current', 'true'); else row.removeAttribute('aria-current');
    });
  };
  ['pushState', 'replaceState'].forEach((fn) => {
    const orig = history[fn];
    history[fn] = function () { const r = orig.apply(this, arguments); setTimeout(sync, 0); return r; };
  });
  window.addEventListener('popstate', sync);
  document.addEventListener('change', (e) => { if (e.target.matches('input[type=radio], select')) setTimeout(sync, 150); });
  sync();
})();
  } catch(e) { console.error(e); }
})();

})();
